import Requester from "../helpers/Requester";
import App from "../layouts/app";
import { router } from "@inertiajs/react";
import PlayerForm from "../components/PlayerForm";
import ContentWrapper from "../components/ContentWrapper";
import PageTitle from "../components/PageTitle";
import PageForm from "../components/PageForm";

export default function PageAdd({ teamId }: { teamId: number }) {

    const savePage = (data: any) => {
        const requester = new Requester();

        requester.post(requester.getUrl(`api/pages`), data).then((response) => {
            router.visit(`/admin/pages`);
        }).catch((error) => {
            alert("Error adding player: " + error.message);
        })
    }

    return (
        <App>
            <PageTitle title="Pages" />
            <ContentWrapper>
                <PageForm onSubmit={savePage} />
            </ContentWrapper>
        </App >
    )
}